module.exports = __webpack_public_path__ + "static/media/contactBg3.dfac3ede.png";